export default __webpack_public_path__ + "static/media/app-bar-login.1f7491c4.svg";